import * as React from 'react';
import { Flex, Box } from 'rebass';
import { Titlebar } from '../';
export default function PageLayout(_a) {
    var noPadding = _a.noPadding, title = _a.title, content = _a.content, leftContent = _a.leftContent, centreContent = _a.centreContent, rightContent = _a.rightContent, children = _a.children, scrollable = _a.scrollable;
    return (React.createElement(Flex, { flex: "1", flexDirection: "column", sx: { maxWidth: '100%', overflow: 'hidden' } },
        React.createElement(Box, { flex: "0 0 auto", sx: { boxShadow: 'pageTitle', zIndex: 99 } },
            React.createElement(Titlebar, { title: title, content: content, leftContent: leftContent, centreContent: centreContent, rightContent: rightContent })),
        React.createElement(Box, { flex: "1 1 auto", px: noPadding ? 0 : 10, py: noPadding ? 0 : 7, sx: { height: '100%', overflow: scrollable ? 'auto' : 'hidden' }, bg: "neutral_3" },
            children,
            scrollable && React.createElement(Box, { pb: noPadding ? 0 : 7 }))));
}
